import { render } from "./BaseSpinner.vue?vue&type=template&id=1e56a1e4&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=1e56a1e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e56a1e4"

export default script